import React from "react";
import Carousel from 'react-bootstrap/Carousel';
import { Link } from 'react-router-dom';
import FeaturedSlider from "../Component/FeaturedSlider";
import SearchPanel from "../Component/SearchPanel";
import TodayEvents from "../Component/TodayEvents";

const Home = () =>{
 
  return (
    <div className="Home">
      
      <section className='main-slider banner-align'>
        <Carousel fade>
            <Carousel.Item>
              <img
                  className="d-block w-100"
                  src="./assets/img/homeslider/home-1.jpg"
                  alt=""
                  />
            </Carousel.Item>
            <Carousel.Item>
              <img
                  className="d-block w-100"
                  src="./assets/img/homeslider/home-2.jpg"
                  alt=""
                  />
            </Carousel.Item>
            <Carousel.Item>
              <img
                  className="d-block w-100"
                  src="./assets/img/homeslider/home-3.jpg"
                  alt=""
                  />
            </Carousel.Item>
            <Carousel.Item>
              <img
                  className="d-block w-100"
                  src="./assets/img/homeslider/home-4.jpg"
                  alt=""
                  />
            </Carousel.Item>
            <Carousel.Item>
              <img
                  className="d-block w-100"
                  src="./assets/img/homeslider/home-5.jpg"
                  alt=""
                  />
            </Carousel.Item>
            <Carousel.Item>
              <img
                  className="d-block w-100"
                  src="./assets/img/homeslider/home-6.jpg"
                  alt=""
                  />
            </Carousel.Item>
            <Carousel.Item>
              <img
                  className="d-block w-100"
                  src="./assets/img/homeslider/home-7.jpg"
                  alt=""
                  />
            </Carousel.Item>

        </Carousel>
      </section>
      <SearchPanel/>
      
      <section className='information-common'>
        <div className='container'>
          <div className="row">
            <div className="col-lg-6">
              <div className='information-content'>
                <h1 className="info-large">Welcome to Habib University’s Library <br/> Information Commons.</h1>
                <p>This is a multi-disciplinary learning space serving the faculty, students, researchers and staff of the university. The HU LICS aspires to be one of the finest repositories of knowledge and play a critical role in the growth of scholarship and innovative research in the region. The space supplements Habib University’s vision of innovation, creativity and knowledge creation. Our vision is “Promoting and facilitating the culture of critical inquiry, research, scholarship, collaboration and self-directed lifelong learning”. Currently, the library houses a unique and diverse collection of <b>24000 print books, 100,000 e-books</b> and <b>9000+ Journals</b>.</p>
              </div>
            </div>
            <div className="col-lg-6">
                <div className='information-img'>
                    <img className='img-fluid' src='./assets/img/welcome-image.jpg' alt=""/>
                </div>
            </div>
          </div>
        </div>
      </section>

     <section className='coob-area'>
        <div className="container">
              <div className='featured-top'>
                <div className='information-content'>
                  <h2>Check out our books</h2>
                  <p>Join us at our organized events and happenings</p>
                </div>
              </div>
              <div className="bookStates">
                <div className="lirabry-inner">
                  <div className="library-box">
                    <div className="icon-hvr">
                      <img src="./assets/img/print-books-icon.svg" alt=""/>
                    </div>
                    <h5>24000+</h5>
                    <h6>Total print books</h6>   
                  </div>
                  <div className="library-box">
                    <div className="icon-hvr">
                      <img src="./assets/img/e-book-icon.svg" alt=""/>
                    </div>
                    <h5>91000+</h5>
                    <h6>E-Books</h6>  
                  </div>
                  <div className="library-box">
                    <div className="icon-hvr">
                       <img src="./assets/img/research-report-icon.svg" alt=""/>
                    </div>
                    <h5>5000+</h5>
                    <h6>Research Reports</h6>  
                  </div>
                  <div className="library-box">
                    <div className="icon-hvr">
                      <img src="./assets/img/online-journals-icon.svg" alt=""/>
                    </div>
                    <h5>9000+</h5>
                    <h6>Online Journals</h6>  
                  </div>
                </div>
              </div>
        </div>
     </section>
      <section className='ad-message-section'>
        <div className='container'>
          <div className="row align-items-center">
            <div className="col-lg-6 col-md-5">
                <div className='ad-imgWrap'>
                    <img className='img-fluid' src='./assets/img/nooruddin-merchant.jpg' alt=""/>
                </div>
            </div>
            <div className="col-lg-6 col-md-7">
              <div className='ad-message-box'>
                <div className="ad-qoute-icon">
                  <img className='img-fluid' src='./assets/img/qoute-icon.svg' alt=""/>
                </div>
                <p>Our aim is to cultivate critical inquiry through collaborative learning spaces that inspire curiosity and lifelong academic engagement.</p>
                <h4>Nooruddin Merchant</h4>
                <h5>Assistant Director, Library and Education Programs, Habib University</h5>
              </div>
            </div>
          </div>
        </div>
      </section>
      <section className='feature-area bg-gradient'>
        <div className="container">
              <div className='featured-top'>
                <div className='information-content'>
                  <h2>Featured Collection</h2>
                  <p>Browse Habib University Library Catalog</p>
                </div>
                <a href={"https://catalog.habib.edu.pk/cgi-bin/koha/opac-main.pl"} target="_blank" className='btn-dfault'>
                    View all collection
                </a>
              </div>
        </div>
  
        <div className="featured-slider-scroll">
          <div className="featured-slider">
              <FeaturedSlider/>
          </div>
        </div>

      </section>

      <section className="library-services">
          <div className="container">
            <div className="row">
              <div className="col-lg-5">
                <div className="library-serv">
                  <div className='information-content'>
                    <h2>Library Services</h2>
                    <p>Habib University’s library team aims to provide students with adequate facilities for learning with passion. With a range of academic services available, it creates an environment that supports learning, teaching, and research. The library provides a stimulating user centred environment, learning spaces, and customer services supported by digital technologies.</p>
                    <Link as={Link} to="/LibraryServices" className='btn-dfault'>
                      Browse all Services
                    </Link>
                  </div>
                </div>
              </div>
              <div className="col-lg-7 ps-lg-0">
                <div className="lirabry-inner">
                  <a className="library-box" target="_self" href="./ResearchSupport">
                    <div className="icon-hvr">
                      <img src="./assets/img/borrowing-icon.svg" alt=""/>
                    </div>
                    <h5>Research Support</h5>
                  </a>
                  <a className="library-box" target="_self" href="./FindResources">
                    <div className="icon-hvr">
                      <img src="./assets/img/refrence-service-icon.svg" alt=""/>
                    </div>
                    <h5>Find Resources</h5>
                  </a>
                  <a className="library-box" target="_self" href="./AskaLibrarian">
                    <div className="icon-hvr">
                       <img src="./assets/img/helpdesk-icon.svg" alt=""/>
                    </div>
                    <h5>Help Desk</h5>
                  </a>
                  <a className="library-box" target="_self" href="./MakerSpace">
                    <div className="icon-hvr">
                      <img src="./assets/img/mkaerwroksho-icon.svg" alt=""/>
                    </div>
                    <h5>Maker Workshops</h5>
                  </a>
                </div>
              </div>
            </div>
          </div>
      </section>

      <section className="upcoming-events">
          <div className="container">
            <div className="featured-top">
                <div className="information-content">
                  <h2>Upcoming Events</h2>
                  <p>Join us at our organized events and happenings</p>
                </div>
                  <Link  as={Link} to="/EventCalendar" className="btn-dfault">View Calender</Link>
            </div>
            <div className="row today-event-wrapper">
              <div className="col-lg-5">
                <div className="homepageEventHeight" id="style-3">
                  <TodayEvents/>
                </div>
              </div>
              <div className="col-lg-7">
                <div className="event-img">
                  <img src="./assets/img/event-right.jpg" alt=""/>
                </div>
              </div>
            </div>
          </div>
      </section>

     
    </div>
  );
}
export default Home;